import { action } from "satcheljs";

const updateTeamSetupPickerEntrypoints = action(
    "updateTeamSetupPickerEntrypoints",
    () => ({})
);

export default updateTeamSetupPickerEntrypoints;
